export default function CoralvilleHeroSection() {
  return (
    <section className="relative min-h-[580px] flex items-center bg-[#1A365D] overflow-hidden">
      <div className="absolute inset-0">
        <img src="https://readdy.ai/api/search-image?query=Iowa%20River%20Landing%20modern%20mixed-use%20development%20with%20reflective%20glass%20buildings%20along%20waterfront%2C%20pedestrian%20bridge%2C%20upscale%20shops%20and%20restaurants%2C%20clear%20blue%20sky%2C%20golden%20hour%20warm%20lighting%2C%20wide%20angle%20architectural%20photography%2C%20professional%20commercial%20real%20estate%20style%2C%20lush%20landscaping&width=1600&height=900&seq=coralville-hero-5&orientation=landscape" alt="Coralville Iowa River Landing skyline at golden hour" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/45"></div>
      </div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-24 md:py-32">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-[#F6C344]/15 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6 border border-[#F6C344]/30">
            <i className="ri-shield-check-line text-[#F6C344] text-sm"></i>
            <span className="text-[#F6C344] text-xs font-bold uppercase tracking-widest">A+ BBB Rated — Registered State Dept. Courier</span>
          </div>
          <h1 className="font-serif text-4xl md:text-6xl font-bold text-white mb-5 leading-tight">
            Emergency Passport<br /><span className="text-[#F6C344]">Coralville, IA</span>
          </h1>
          <p className="text-white/70 text-lg md:text-xl leading-relaxed mb-4 max-w-xl">
            Expedited passport services for Iowa River Landing professionals, University of Iowa travelers, and Johnson County families — as fast as 24 hours.
          </p>
          <p className="text-white/50 text-sm mb-8 max-w-lg">
            Start online from Coralville. Ship documents overnight. We submit through reserved courier agency availability — no need to drive to Chicago.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a href="https://fastpassportcenter.com/checkout/" className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 text-center whitespace-nowrap">
              Get My Passport Fast <i className="ri-arrow-right-line ml-1.5"></i>
            </a>
            <a href="tel:8772530084" className="border-2 border-white/20 hover:border-[#F6C344] text-white font-semibold text-base px-8 py-4 rounded-md transition-all text-center whitespace-nowrap">
              <i className="ri-phone-line mr-1.5"></i> 877-253-0084
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}